module.exports = __webpack_public_path__ + "img/symbol_2.e5cc9746.png";